import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import GenericSelection from '../Common/GenericSelection';
import { 
  SALES_ORDER_DROPDHIP_URL, 
  SALES_ORDER_MERGE_TO_PO_URL,
  CUSTOMER_BUYER_URL,
 } from '../../actions/url';
import { isVAK, ROOT_URL, isAP, isAPD } from '../../actions/root_url';
import _ from 'lodash';

const fetchWarehouses = (companyid, success) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/warehouse/get_warehouse_by_company/${companyid}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then(res => {
      success(res.data);;
    })
    .catch(err => {
      console.log('err', err);
    })
}

const fetchVendorWithCompany = (companyId, success) => {
  let url = `${ROOT_URL}v1/vendor/?Company_id=${companyId}`;
  if (isVAK) {
    url += '&is_active=true';
  }
  axios({
    method: 'GET',
    url,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then(res => {
      success(res.data);
    })
    .catch(err => {
      console.log('err', err);
    })
}

const propTypes = {
  salesOrderId: PropTypes.string.isRequired,
  vendors: PropTypes.array,
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

const defaultProps = {
  vendors: [],
};

const styles = {
  modal: {
    width: '400px',
    height: '270px',
    marginLeft: '-9%',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
};

class DropshipModal extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      vendorOptions: [],
      selectedCompany: null,
      selectedVendorId: undefined,
      warehouseOptions: [],
      selectedWarehouse: null,
      buyerList: [],
      buyer: undefined,
    };
    this.handleSelectVendor = this.handleSelectVendor.bind(this);
    this.createPo = this.createPo.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (isAP && nextProps.visible != this.props.visible) {
      if(nextProps.visible) {
        this.setState({//customerDeliverId
          selectedCompany: this.props.activiteCompany,
          selectedWarehouse: this.props.activiteWarehouse,
          buyer: nextProps.customerBuyerId ,
        })
        this.handleGetCompanyAndWarehouseInfo(this.props.activiteCompany);
        this.handleFetchBuyerList(nextProps.customerDeliverId);
      } else {
        this.setState({
          buyerList: [],
          buyer: undefined,
          selectedCompany: null,
          selectedVendorId: undefined,
        })
      }
    }
  }

  handleSelectVendor({value}) {
    this.setState({ selectedVendorId: value });
  }
  handleSelectBuyer({value}) {
    this.setState({ buyer: value });
  }

  handleWarehouseSelect = ({ value: selectedWarehouse }) => this.setState({ selectedWarehouse });

  handleSelectCompany = (selectedCompany) => {
    this.setState({
      selectedCompany,
      vendorOptions: [],
      selectedVendorId: null,
      warehouseOptions: [],
      selectedWarehouse: null,
    });
    this.handleGetCompanyAndWarehouseInfo(selectedCompany);
  }

  handleGetCompanyAndWarehouseInfo = (selectedCompany) => {
    const success = (vendors) => {
      this.setState({
        vendorOptions: vendors.map(vendor => ({
          label: isAP ? `${vendor.Name}-Lv${vendor.Level}` : vendor.Name,
          value: vendor.Vendor_id,
        })),
      })
    }
    const updateWarehouse = (warehouses) => {
      this.setState({
        warehouseOptions: warehouses.map(warehouse => ({
          label: warehouse.name,
          value: warehouse.id,
        }))
      })
    }
    fetchWarehouses(selectedCompany.value, updateWarehouse)
    fetchVendorWithCompany(selectedCompany.value, success)
  }

  handleFetchBuyerList = (id) => {
    axios({
      method: 'GET',
      url: `${CUSTOMER_BUYER_URL}?customer_id=${id}`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then(res => {
        this.setState({
          buyerList: res.data.map(dat => ({ label: dat.FirstName, value: dat.id })),
        })
      })
  }

  createMergeTOPO = () => {
    const { selectedVendorId, buyer } = this.state;
    const { salesOrderId } = this.props;
    if (!selectedVendorId) {
      alert('Please enter a vendor.');
      return;
    }
    if (!buyer) {
      alert('Please select a buyer.');
      return;
    }
    this.setState({
      loading: true,
    });
    axios.post(SALES_ORDER_MERGE_TO_PO_URL, {
      vendor_id: selectedVendorId,
      warehouse_id: this.state.selectedWarehouse.value || this.state.selectedWarehouse,
      company_id: this.state.selectedCompany.value || this.state.selectedCompany,
      so_ids: salesOrderId,
      customer_buyer_id: buyer,
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then((response) => {
      this.setState({ loading: false })
      alert('Create Success');
      // const { purchase_order_id } = response.data;
      // window.location.pathname = `/prepareOrder/${purchase_order_id}`;
      this.props.handleCreatePOSuccess();
    }).catch((err) => {
      this.setState({ loading: false })
      alert(JSON.stringify(err.data));
    });

  }

  createPo = _.debounce(() => {
    const { selectedVendorId } = this.state;
    const { salesOrderId, isMerge = false } = this.props;
    if (isMerge) {
      this.createMergeTOPO();
      return
    }
    if (!selectedVendorId) {
      alert('Please select a vendor.');
      return;
    }
    this.setState({
      loading: true,
    });
    axios.post(`${SALES_ORDER_DROPDHIP_URL}${salesOrderId}`, {
      vendor_id: selectedVendorId,
      warehouse_id: this.state.selectedWarehouse.value || this.state.selectedWarehouse,
      company_id: this.state.selectedCompany.value || this.state.selectedCompany,
      IsDropship: true, //vak dropship
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then((response) => {
      const { purchase_order_id } = response.data;
      if (isAPD) {
        window.location.pathname = `/salesOrders`;
      } else {
        window.location.pathname = `/purchaseOrder/${purchase_order_id}`;
      }
      this.props.handleCreatePOSuccess();
    }).catch((err) => {
      this.setState({ loading: false })
      alert(JSON.stringify(err.data.message));
      // alert('Internal Server Error. Please try again.');
    });
  }, 500);

  render() {
    const {
      visible,
      onClose,
      companyOptions,
    } = this.props;
    return (
      <SkyLightStateless
        dialogStyles={styles.modal}
        isVisible={visible}
        onCloseClicked={onClose}
        title={isAPD ? <Translate value="dropship_vendor" /> : ''}
      >
        <div style={styles.container} className="salesOrder-dropship">
          <GenericSelection
            translation={<Translate value="company" />}
            setSelected={this.handleSelectCompany}
            value={this.state.selectedCompany}
            options={companyOptions}
            colon
            containerStyle={{ padding: '5px' }}
            labelStyle={{ width: '65px' }}
          />
          <GenericSelection
            translation={<Translate value="warehouse" />}
            setSelected={this.handleWarehouseSelect}
            value={this.state.selectedWarehouse}
            options={this.state.warehouseOptions}
            colon
            containerStyle={{ padding: '5px' }}
            labelStyle={{ width: '65px' }}
          />
          <GenericSelection
            translation={<Translate value="vendor" />}
            setSelected={this.handleSelectVendor}
            value={this.state.selectedVendorId}
            options={this.state.vendorOptions}
            colon
            containerStyle={{ padding: '5px' }}
            labelStyle={{ width: '65px' }}
          />
          <GenericSelection
            translation={<Translate value="buyer" />}
            setSelected={(e)=> {this.handleSelectBuyer(e)}}
            value={this.state.buyer}
            options={this.state.buyerList}
            colon
            containerStyle={{ padding: '5px' }}
            labelStyle={{ width: '65px' }}
          />
          <div style={{ marginTop: 20 }}>
            <Button
              bsStyle="primary"
              onClick={this.createPo}
              disabled={!this.state.selectedCompany || !this.state.selectedWarehouse || this.state.loading}
            >
              <Translate value="create_po" />
            </Button>
          </div>
        </div>
      </SkyLightStateless>
    );
  }
}

DropshipModal.propTypes = propTypes;
DropshipModal.defaultProps = defaultProps;

const mapStateToProps = state => ({
  companyOptions: state.header.companies.map(company => ({
    label: company.Name,
    value: company.id,
  })),
  activiteCompany: state.header.selectedCompany,
  activiteWarehouse: state.header.selectedWarehouse,
});

export default connect(mapStateToProps)(DropshipModal);



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/DropshipModal.jsx